import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungDuisburg() {
  return (
    <CityPageTemplate
      city="Duisburg"
      slug="duisburg"
      intro="Duisburg im Aufbruch – wir helfen Dir, die richtigen finanziellen Weichen jetzt zu stellen."
      description="Unabhängige Finanzberatung für Duisburg – 100% digital, kostenlose Erstberatung. Altersvorsorge, ETF, Steueroptimierung & staatliche Förderungen."
    />
  );
}
